/**
 * Parse monetary/qty strings from invoices:
 * - US: 1,234.56 or 250.00
 * - European: 1.234,56 or 250,00 (comma decimal — must not become 25000)
 * - Plain: 25000
 */
export function parseInvoiceAmount(value) {
  if (value === '' || value == null) return '';
  if (typeof value === 'number' && Number.isFinite(value)) return value;

  let raw = String(value).trim();
  if (!raw) return '';

  const neg = /^-/.test(raw);
  raw = raw.replace(/^-/, '').trim();

  raw = raw.replace(/^[₹$€£Rs.\s]+/i, '').trim();

  let core = raw.replace(/[^\d,.-]/g, '').replace(/-/g, '');
  if (!core) return '';

  if (!core.includes(',') && !core.includes('.')) {
    const n = Number(core);
    return Number.isFinite(n) ? (neg ? -n : n) : '';
  }

  const lastComma = core.lastIndexOf(',');
  const lastDot = core.lastIndexOf('.');

  let normalized;
  if (!core.includes('.') && core.includes(',')) {
    const parts = core.split(',');
    if (parts.length === 2 && parts[1].length >= 1 && parts[1].length <= 2 && /^\d+$/.test(parts[1])) {
      normalized = parts[0].replace(/\./g, '') + '.' + parts[1];
    } else {
      normalized = core.replace(/,/g, '');
    }
  } else if (lastComma > lastDot) {
    const withoutDots = core.replace(/\./g, '');
    const lastC = withoutDots.lastIndexOf(',');
    normalized =
      lastC >= 0
        ? withoutDots.slice(0, lastC).replace(/,/g, '') + '.' + withoutDots.slice(lastC + 1)
        : withoutDots;
  } else {
    normalized = core.replace(/,/g, '');
  }

  const n = Number(normalized);
  if (!Number.isFinite(n)) return '';
  return neg ? -n : n;
}
